import api from "./api";

/* ==========================
   SAFE REQUEST
========================== */
const safeRequest = async (fn) => {
    try {
        const res = await fn();
        const data = res?.data;

        return {
            ok: true,
            data: Array.isArray(data) ? data : data?.data ?? data,
        };
    } catch (error) {
        
        console.warn("API error:", error?.response?.data ?? error?.message);

        return {
            ok: false,
            data: null,
            message:
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                error?.message ||
                "Request failed",
        };
    }
};

/* ==========================
   ROLES API
========================== */
export const getRoles = async () => {
    const res = await api.get("/role");
    return res.data;
};
export const getRolesRaw = async () => {
    const res = await api.get("/role");
    return res.data;
};

export const getRoleById = async (id) => {
    return safeRequest(() => api.get(`/role/${id}`));
};

export const createRole = async (data) => {
    return safeRequest(() => api.post("/role", data));
};

export const updateRole = async (id, data) => {
    return safeRequest(() => api.put(`/role/${id}`, data));
};

export const deleteRole = async (id) => {
    return safeRequest(() => api.delete(`/role/${id}`));
};